import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import {
  AlertDataI,
  AlertService2,
} from 'src/app/core/services/alert2.service';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnInit, OnDestroy {
  alert: AlertDataI | null = null;
  private sub!: Subscription;

  constructor(private alertService: AlertService2) {}

  ngOnInit() {
    this.sub = this.alertService.alert$.subscribe((data) => {
      this.alert = data;
      if (data.autoDismiss) {
        timer(4000).subscribe(() => (this.alert = null));
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  close() {
    this.alert = null;
  }
}
